import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
import SeoMetaTextBlock from 'components/SeoMetaTextBlock';
import BreadCrumbs from 'components/HomePageBreadCrumbs';
import Banner from 'components/Banner';
import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const HomePageFooter = memo(() => (
  <Wrapper>
    <SeoMetaTextBlock />
    <SeoTextsBlocks />
    <BreadCrumbsWrapper>
      <BreadCrumbs />
    </BreadCrumbsWrapper>
    <Banner id="rp-react-banner-catfish" slot="bn-slot-catfish" />
  </Wrapper>
));

export default HomePageFooter;
